<div [ngClass]="loading ? 'lock' : ''">
  <div class="flex flex-row">
    <h2 class="page-header">{{ getPageTitle() }}</h2>
    <button
      mat-flat-button
      class="action-button"
      style="margin: 20px"
      [routerLink]="[getRouterLinkNew()]"
    >
      + {{ newProjectLabel }}
    </button>
    <button
      *ngIf="showFromOldSystemButton()"
      mat-flat-button
      class="action-button"
      style="margin: 20px 20px 20px 0"
      [routerLink]="[getRouterLinkCreateOldSystemProject()]"
    >
      + Uit oud systeem
    </button>
  </div>

  <div class="table-container panel">
    <div class="example-table-container">
      <div
        *ngIf="loading"
        class="table-loader-overlay"
        style="margin-top: 55px"
      >
        <div style="margin-top: 145px; align-self: center">
          <mat-spinner
            style="margin: auto"
            color="primary"
            diameter="75"
          ></mat-spinner>
        </div>
      </div>
      <table
        mat-table
        [dataSource]="renderedStream"
        [trackBy]="trackById"
        class="example-table"
        matSort
      >
        <ng-container matColumnDef="project_id">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>#</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('project__id')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [routerLink]="[routerLinkOpen, row.project.id, row.id]"
          >
            <div>
              <div class="d-flex">
                <div class="strong secondary-color">#{{ row.project?.id }}</div>
                <div
                  *ngIf="row.project.oldPlatformId != null"
                  class="font-weight-bold font-italic"
                  [matTooltip]="'Jobnummer oud platform'"
                >
                  &nbsp;({{ row.project.oldPlatformId }})
                </div>
                <div
                  class="collaborative-icon-margin"
                  *ngIf="row.project.collaborative"
                  [matTooltip]="'Gezamenlijk project'"
                >
                  <mat-icon class="scale-collaborative-icon">groups</mat-icon>
                </div>
                <div class="flexer">
                  <mat-icon class="important-icon" *ngIf="showImportant(row)"
                    >flag
                  </mat-icon>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="currentCreatedAt">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Aanvraag</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentCreatedAt')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentCreatedAt | formatDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currentRequestDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Gevraagd</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentRequestDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{
              row.currentRequestDate | formatASAPDate : row.currentRequestASAP
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="quotationByDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Deadline</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('quotationByDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.quotationByDate | formatDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currentPrintDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Printwerk</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentPrintDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentPrintDate | formatASAPDate : row.currentPrintASAP }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currentFinishDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Afwerking</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentFinishDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentFinishDate | formatASAPDate : row.currentFinishASAP }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currentDesignDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Ontwerp</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentDesignDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentDesignDate | formatASAPDate : row.currentDesignASAP }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currentSiteVisitDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Deadline</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentSiteVisitDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentSiteVisitDate | formatDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="approvedOn">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Goedgekeurd op</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ getApprovedOnDate(row, row.project) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currentExecutionDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Uitvoering</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('currentExecutionDate')"
                [isDate]="true"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentExecutionDate | formatDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currentConfirmedPlacementDate">
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]=""
            class="header-text"
          >
            <b>{{ currentConfirmedPlacementDateLabel }}</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentConfirmedPlacementDate | formatDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle extra-right">
                <b>Klant</b>
              </div>
              <filter-input
                [filterObject]="
                  getFilterForKey('project__projectContacts__company__name')
                "
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngFor="
                let c of row.project.involvedCompanies;
                let isLast = last;
                trackBy: trackById
              "
            >
              <span matTooltip="{{ c.regularName }}">{{
                c.regularName | shortenText : 20
              }}</span>
              <span *ngIf="!c.dataCorrect"
                >&nbsp;&nbsp;
                <mat-icon
                  matTooltip="Bedrijf nog niet vervolledigd"
                  class="data-not-correct-icon"
                  >report_problem</mat-icon
                >
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="quotation.approvalRegistration.date">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Goedkeuring offerte</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.quotation?.approvalRegistration?.date | formatDate : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="quotation.disapprovalRegistration.date">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Afgekeurd</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{
              row.quotation?.disapprovalRegistration?.date | formatDate : '-'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="quotation.disapprovalReasons">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Reden afkeuring</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text quotation-rejected-reason-width"
            (click)="openProject(row)"
          >
            <span
              *ngIf="
                row.quotation.approvalReasons != null &&
                row.quotation.approvalReasons.length > 0
              "
              class="preserve-line-break"
              [matTooltip]="row.quotation.approvalReasons"
              >{{ row.quotation?.approvalReasons | shortenText : 125 }}</span
            >
            <span
              *ngIf="
                row.quotation.approvalReasons == null ||
                row.quotation.approvalReasons.length === 0
              "
            >
              -
            </span>
          </td>
        </ng-container>

        <!--      <ng-container matColumnDef="quotationSent">-->
        <!--        <th mat-header-cell *matHeaderCellDef class="header-text">-->
        <!--          <div class="d-flex">-->
        <!--            <div class="text-middle extra-right">-->
        <!--              <b>Verstuurd</b>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </th>-->
        <!--        <td-->
        <!--          mat-cell-->
        <!--          *matCellDef="let row"-->
        <!--          class="table-text"-->
        <!--          (click)="openProject(row)"-->
        <!--        >-->
        <!--          <div *ngFor="let pc of row.projectContacts">-->
        <!--            <span-->
        <!--              ><mat-icon-->
        <!--                *ngIf="quotationSent(pc); else sentEmptyLine"-->
        <!--                class="small-icon"-->
        <!--                svgIcon="check"-->
        <!--              ></mat-icon>-->
        <!--              <ng-template #sentEmptyLine>-->
        <!--                &nbsp;-->
        <!--              </ng-template>-->
        <!--            </span>-->
        <!--          </div>-->
        <!--        </td>-->
        <!--      </ng-container>-->

        <ng-container matColumnDef="quotationComments">
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]=""
            class="header-text"
          >
            <b>Info</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text comments-width"
            (click)="openProject(row)"
          >
            <span
              *ngIf="
                row.quotationComments != null &&
                row.quotationComments.length > 0
              "
              [matTooltip]="row.quotationComments"
              class="preserve-line-break"
              >{{ row.quotationComments | shortenText : 60 }}</span
            >
            <span
              *ngIf="
                row.quotationComments == null ||
                row.quotationComments.length === 0
              "
            >
              -
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="archivalReason">
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]=""
            class="header-text"
          >
            <b>Reden</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div *ngIf="row.quotation?.approved === false">
              <span
                *ngIf="row.quotation.disapprovalRegistration?.date"
                class="preserve-line-break"
                >{{
                  row.quotation.disapprovalRegistration.date | formatDate
                }}</span
              >
              <span
                *ngIf="
                  row.quotation.disapprovalRegistration?.date &&
                  row.quotation.approvalReasons
                "
              >
                -
              </span>
              <span
                *ngIf="row.quotation.approvalReasons"
                class="preserve-line-break"
                [matTooltip]="row.quotation.approvalReasons"
                [matTooltipDisabled]="row.quotation.approvalReasons.length < 30"
                >{{ row.quotation.approvalReasons | shortenText }}</span
              >
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="projectPlacement.address">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <div class="d-flex">
              <div class="text-middle" mat-sort-header>
                <b>Adres</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('projectPlacement__address')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{
              row.projectPlacement?.address?.line1
                | printAddress
                  : row.projectPlacement?.address?.postalCode
                  : row.projectPlacement?.address?.city
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="clientActions">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <b>Acties</b>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div *ngIf="isBaseProject(row)" class="d-flex center-text">
              <div [matTooltip]="'Aanpassing aanvragen'">
                <button
                  class="clickable rounded scale-button"
                  [ngClass]="
                    row.project?.allSubProjectsExecuted
                      ? 'request-adjustment'
                      : 'request-disabled'
                  "
                  [disabled]="!row.project?.allSubProjectsExecuted"
                  (click)="requestAdjustment(row.project)"
                >
                  <mat-icon svgIcon="client-gear"></mat-icon>
                </button>
              </div>
              <div
                class="small-left-space"
                [matTooltip]="'Verkocht/Verhuurd aanvragen'"
              >
                <button
                  class="clickable rounded scale-button follower-button"
                  [ngClass]="
                    row.project?.allSubProjectsExecuted
                      ? 'request-sold-rented'
                      : 'request-disabled'
                  "
                  [disabled]="!row.project?.allSubProjectsExecuted"
                  (click)="requestSoldRented(row.project)"
                >
                  <mat-icon svgIcon="client-check"></mat-icon>
                </button>
              </div>
              <div class="small-left-space" [matTooltip]="'Weghalen aanvragen'">
                <button
                  class="clickable rounded scale-button follower-button"
                  [ngClass]="
                    row.project?.allSubProjectsExecuted
                      ? 'request-repo'
                      : 'request-disabled'
                  "
                  [disabled]="!row.project?.allSubProjectsExecuted"
                  (click)="requestRepo(row.project)"
                >
                  <mat-icon svgIcon="client-arrow"></mat-icon>
                </button>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="productType">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Type(s)</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              class="line-height in-the-middle-left"
              *ngFor="
                let prod of row.project.products;
                let isLast = last;
                trackBy: trackById
              "
              [matTooltip]="prod.type | productType : prod.otherProductName"
            >
              {{ prod.type | abbreviatedProductType : prod.otherProductName }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="detailedProductType">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Type(s)</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              class="line-height in-the-middle-left"
              *ngFor="
                let prod of row.project.products;
                let isLast = last;
                trackBy: trackById
              "
              matTooltip="{{
                prod.type
                  | productType : prod.otherProductName : prod.overviewFormat
                  | joiner : ' - ' : prod.boardType : prod.placementType
              }}"
            >
              {{ prod.type | abbreviatedProductType : prod.otherProductName }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="productSize">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Formaat</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              class="line-height in-the-middle-left"
              *ngFor="
                let prod of row.project.products;
                let isLast = last;
                trackBy: trackById
              "
            >
              {{ prod.overviewFormat }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="boardTypeAndPlacement">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Type bord</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              class="line-height in-the-middle-left"
              *ngFor="
                let prod of row.project.products;
                let isLast = last;
                trackBy: trackById
              "
            >
              {{
                prod.boardType
                  | joiner : ' - ' : prod.placementType
                  | shortenText : 32
              }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="project.products.materialDisplayName">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" mat-sort-header>
                <b>Materiaal</b>
              </div>
              <filter-input
                [filterObject]="
                  getFilterForKey('project__products__materialDisplayName')
                "
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              class="line-height in-the-middle-left"
              *ngFor="
                let prod of row.project.products;
                let isLast = last;
                trackBy: trackById
              "
            >
              {{ prod.materialDisplayName }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="designer">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <div class="d-flex">
              <div class="text-middle extra-right">
                <b>Ontwerper</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('designers__project')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="let prod of row.project.products; trackBy: trackById"
              >
                <div
                  *ngIf="prod.designer"
                  class="employee-initials rounded-circle in-the-middle placer-margin"
                  [matTooltip]="
                    prod.designer.user?.firstName
                      | personName : prod.designer.user?.lastName
                  "
                >
                  <span *ngIf="!prod.designer.user?.profilePicture">
                    {{
                      prod.designer.user?.firstName
                        | initials : prod.designer.user?.lastName
                    }}
                  </span>
                  <span *ngIf="prod.designer.user?.profilePicture">
                    <img
                      class="rounded-circle"
                      width="30px"
                      height="30px"
                      [src]="
                        '/api/assets/' +
                        prod.designer.user?.profilePicture?.uuid +
                        '/30'
                      "
                    />
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="!isBaseProject(row) && row.adjustmentDesigner != null"
            >
              <div
                class="employee-initials rounded-circle in-the-middle placer-margin"
                [matTooltip]="
                  row.adjustmentDesigner.user?.firstName
                    | personName : row.adjustmentDesigner.user?.lastName
                "
              >
                <span *ngIf="!row.adjustmentDesigner.user?.profilePicture">
                  {{
                    row.adjustmentDesigner.user?.firstName
                      | initials : row.adjustmentDesigner.user?.lastName
                  }}
                </span>
                <span *ngIf="row.adjustmentDesigner.user?.profilePicture">
                  <img
                    class="rounded-circle"
                    width="30px"
                    height="30px"
                    [src]="
                      '/api/assets/' +
                      row.adjustmentDesigner.user.profilePicture.uuid +
                      '/30'
                    "
                  />
                </span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="designInfo">
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]=""
            class="header-text"
          >
            <b>Info</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text comments-width"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="let prod of row.project.products; trackBy: trackById"
              >
                <span
                  *ngIf="
                    prod.needsDesignDescription != null &&
                    prod.needsDesignDescription.length > 0
                  "
                  [matTooltip]="prod.needsDesignDescription"
                  class="preserve-line-break"
                  >{{ prod.needsDesignDescription | shortenText : 60 }}</span
                >
              </div>
            </ng-container>
            <ng-container *ngIf="!isBaseProject(row)">
              <span
                *ngIf="
                  row.extraInfoDesign != null && row.extraInfoDesign.length > 0
                "
                [matTooltip]="row.extraInfoDesign"
                class="preserve-line-break"
                >{{ row.extraInfoDesign | shortenText : 60 }}</span
              >
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="printworkHandler">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <div class="d-flex">
              <div class="text-middle extra-right">
                <b>Drukker</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('printworkHandlers__project')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="let prod of row.project.products; trackBy: trackById"
              >
                <div
                  *ngIf="prod.printworkHandler"
                  class="employee-initials rounded-circle in-the-middle placer-margin"
                  [matTooltip]="
                    prod.printworkHandler.user?.firstName
                      | personName : prod.printworkHandler.user?.lastName
                  "
                >
                  <span *ngIf="!prod.printworkHandler.user?.profilePicture">{{
                    prod.printworkHandler.user?.firstName
                      | initials : prod.printworkHandler.user?.lastName
                  }}</span>
                  <span *ngIf="prod.printworkHandler.user?.profilePicture">
                    <img
                      class="rounded-circle"
                      width="30px"
                      height="30px"
                      [src]="
                        '/api/assets/' +
                        prod.printworkHandler.user?.profilePicture?.uuid +
                        '/30'
                      "
                    />
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                !isBaseProject(row) && row.adjustmentPrintworkHandler != null
              "
            >
              <div
                class="employee-initials rounded-circle in-the-middle placer-margin"
                [matTooltip]="
                  row.adjustmentPrintworkHandler.user?.firstName
                    | personName : row.adjustmentPrintworkHandler.user?.lastName
                "
              >
                <span
                  *ngIf="!row.adjustmentPrintworkHandler.user?.profilePicture"
                >
                  {{
                    row.adjustmentPrintworkHandler.user?.firstName
                      | initials : row.adjustmentPrintworkHandler.user?.lastName
                  }}
                </span>
                <span
                  *ngIf="row.adjustmentPrintworkHandler.user?.profilePicture"
                >
                  <img
                    class="rounded-circle"
                    width="30px"
                    height="30px"
                    [src]="
                      '/api/assets/' +
                      row.adjustmentPrintworkHandler.user.profilePicture.uuid +
                      '/30'
                    "
                  />
                </span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="printInfo">
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]=""
            class="header-text"
          >
            <b>Info</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text comments-width"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="let prod of row.project.products; trackBy: trackById"
              >
                <span
                  *ngIf="
                    prod.noPrintworkExtraInfo != null &&
                    prod.noPrintworkExtraInfo.length > 0
                  "
                  [matTooltip]="prod.noPrintworkExtraInfo"
                  class="preserve-line-break"
                  >{{ prod.noPrintworkExtraInfo | shortenText : 60 }}</span
                >
              </div>
            </ng-container>
            <ng-container *ngIf="!isBaseProject(row)">
              <span
                *ngIf="
                  row.printworkExtraInfo != null &&
                  row.printworkExtraInfo.length > 0
                "
                [matTooltip]="row.printworkExtraInfo"
                class="preserve-line-break"
                >{{ row.printworkExtraInfo | shortenText : 60 }}</span
              >
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="finisher">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <div class="d-flex">
              <div class="text-middle extra-right">
                <b>Afwerker</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('finishers__project')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="let prod of row.project.products; trackBy: trackById"
              >
                <div
                  *ngIf="prod.finisher"
                  class="employee-initials rounded-circle in-the-middle placer-margin"
                  [matTooltip]="
                    prod.finisher.user?.firstName
                      | personName : prod.finisher.user?.lastName
                  "
                >
                  <span *ngIf="!prod.finisher.user?.profilePicture">{{
                    prod.finisher.user?.firstName
                      | initials : prod.finisher.user?.lastName
                  }}</span>
                  <span *ngIf="prod.finisher.user?.profilePicture">
                    <img
                      class="rounded-circle"
                      width="30px"
                      height="30px"
                      [src]="
                        '/api/assets/' +
                        prod.finisher.user?.profilePicture?.uuid +
                        '/30'
                      "
                    />
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="!isBaseProject(row) && row.adjustmentFinisher != null"
            >
              <div
                class="employee-initials rounded-circle in-the-middle placer-margin"
                [matTooltip]="
                  row.adjustmentFinisher.user?.firstName
                    | personName : row.adjustmentFinisher.user?.lastName
                "
              >
                <span *ngIf="!row.adjustmentFinisher.user?.profilePicture">
                  {{
                    row.adjustmentFinisher.user?.firstName
                      | initials : row.adjustmentFinisher.user?.lastName
                  }}
                </span>
                <span *ngIf="row.adjustmentFinisher.user?.profilePicture">
                  <img
                    class="rounded-circle"
                    width="30px"
                    height="30px"
                    [src]="
                      '/api/assets/' +
                      row.adjustmentFinisher.user.profilePicture.uuid +
                      '/30'
                    "
                  />
                </span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="placer">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Plaatsers</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('placers__project')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="isBaseProject(row)">
              <div
                class="line-height"
                *ngFor="let prod of row.project.products; trackBy: trackById"
              >
                <div *ngIf="prod.productPlacement">
                  <div class="d-flex">
                    <div
                      *ngFor="
                        let placer of prod.productPlacement.placers;
                        trackBy: trackById
                      "
                      class="employee-initials rounded-circle in-the-middle placer-margin"
                      [matTooltip]="
                        placer.user?.firstName
                          | personName : placer.user?.lastName
                      "
                    >
                      <span *ngIf="!placer.user?.profilePicture">
                        {{
                          placer.user?.firstName
                            | initials : placer.user?.lastName
                        }}
                      </span>
                      <span *ngIf="placer.user?.profilePicture">
                        <img
                          class="rounded-circle"
                          width="30px"
                          height="30px"
                          [src]="
                            '/api/assets/' +
                            placer.user.profilePicture.uuid +
                            '/30'
                          "
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                !isBaseProject(row) && row.projectPlacement?.placers != null
              "
            >
              <div class="d-flex">
                <div
                  *ngFor="
                    let placer of row.projectPlacement.placers;
                    trackBy: trackById
                  "
                  class="employee-initials rounded-circle in-the-middle placer-margin"
                  [matTooltip]="
                    placer.user?.firstName | personName : placer.user?.lastName
                  "
                >
                  <span *ngIf="!placer.user?.profilePicture">
                    {{
                      placer.user?.firstName | initials : placer.user?.lastName
                    }}
                  </span>
                  <span *ngIf="placer.user?.profilePicture">
                    <img
                      class="rounded-circle"
                      width="30px"
                      height="30px"
                      [src]="
                        '/api/assets/' + placer.user.profilePicture.uuid + '/30'
                      "
                    />
                  </span>
                </div>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="locationVerified">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Locatie</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div class="line-height">
              <div *ngIf="isBaseProject(row)">
                <div
                  *ngIf="
                    row.projectPlacement
                      ?.locationVerificationCheckedByExpert === true
                  "
                  [matTooltip]="'Locatiebepaling in orde'"
                  class="medium-left-space"
                >
                  <span style="margin-top: 7.5px">
                    <mat-icon class="checkmark" svgIcon="check"></mat-icon>
                  </span>
                </div>
                <div
                  *ngIf="
                    row.projectPlacement
                      ?.locationVerificationCheckedByExpert === false
                  "
                  [matTooltip]="'Locatiebepaling niet in orde'"
                  class="medium-left-space"
                >
                  <span>
                    <mat-icon class="location-verification-warning"
                      >report_problem</mat-icon
                    >
                  </span>
                </div>
              </div>
              <div *ngIf="!isBaseProject(row)">
                <div
                  *ngIf="
                    row.projectPlacement?.doLocationVerification &&
                    row.projectPlacement
                      ?.locationVerificationCheckedByExpert === true
                  "
                  [matTooltip]="'Locatiebepaling in orde'"
                  class="medium-left-space"
                >
                  <span style="margin-top: 7.5px">
                    <mat-icon class="checkmark" svgIcon="check"></mat-icon>
                  </span>
                </div>
                <div
                  *ngIf="
                    row.projectPlacement?.doLocationVerification &&
                    row.projectPlacement
                      ?.locationVerificationCheckedByExpert === false
                  "
                  [matTooltip]="'Locatiebepaling niet in orde'"
                  class="medium-left-space"
                >
                  <span>
                    <mat-icon class="location-verification-warning"
                      >report_problem</mat-icon
                    >
                  </span>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="siteVisitNeeded">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Werfbezoek</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="
                row.projectPlacement.siteVisit &&
                row.projectPlacement.siteVisitExecuted
              "
              [matTooltip]="'Werfbezoek uitgevoerd'"
              class="medium-left-space"
            >
              <span style="margin-top: 7.5px">
                <mat-icon
                  class="checkmark-no-top-margin"
                  svgIcon="check"
                ></mat-icon>
              </span>
            </div>
            <div
              *ngIf="
                row.projectPlacement?.siteVisit &&
                !row.projectPlacement?.siteVisitExecuted
              "
              [matTooltip]="'Werfbezoek nog niet uitgevoerd'"
              class="medium-left-space"
            >
              <span>
                <mat-icon class="location-verification-warning"
                  >report_problem</mat-icon
                >
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="externalSupplierNeeded">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Externe lev.</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="row.needExternalSupplier === false"
              [matTooltip]="'Externe leveranciers in orde'"
              class="medium-left-space"
            >
              <span style="margin-top: 7.5px">
                <mat-icon
                  class="checkmark-no-top-margin"
                  svgIcon="check"
                ></mat-icon>
              </span>
            </div>
            <div
              *ngIf="row.needExternalSupplier"
              [matTooltip]="'Externe leveranciers nog niet in orde'"
              class="medium-left-space"
            >
              <span>
                <mat-icon class="location-verification-warning"
                  >report_problem</mat-icon
                >
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="externalSupplierDeadline">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Deadline</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text no-top-bottom-padding"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="row.type === 'BaseProject'">
              <div
                *ngFor="let prod of row.project.products; trackBy: trackById"
                class="in-the-middle-left"
              >
                <div>
                  <ng-container
                    *ngIf="prod.externalSupplierDeadlines?.length > 0"
                  >
                    <div
                      *ngFor="let deadline of prod.externalSupplierDeadlines"
                    >
                      <span>{{ deadline | formatDate : '-' }}</span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      prod.externalSupplierDeadlines == null ||
                      prod.externalSupplierDeadlines.length === 0
                    "
                  >
                    <div>&nbsp;</div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                row.type !== 'BaseProject' &&
                row.externalSupplierDeadlines?.length > 0
              "
            >
              <div *ngFor="let deadline of row.externalSupplierDeadlines">
                <span>{{ deadline | formatDate : '-' }}</span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="externalSupplierInfo">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Info</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text comments-width no-top-bottom-padding"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="row.type === 'BaseProject'">
              <div
                *ngFor="let prod of row.project.products; trackBy: trackById"
                class="in-the-middle-left"
              >
                <div>
                  <ng-container *ngIf="prod.externalSupplierLines?.length > 0">
                    <div
                      class="d-flex"
                      *ngFor="let line of prod.externalSupplierLines"
                      [matTooltip]="line.line"
                      [matTooltipDisabled]="
                        line.line == null || line.line.length === 0
                      "
                    >
                      <mat-icon
                        *ngIf="line.finished"
                        svgIcon="check"
                        class="text-checkmark"
                      ></mat-icon>
                      <div>
                        <span class="strong">{{ line.header }}</span>
                        <span class="preserve-line-break">{{
                          line.line | shortenText : 50 | or
                        }}</span>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      prod.externalSupplierLines == null ||
                      prod.externalSupplierLines.length === 0
                    "
                  >
                    <div>&nbsp;</div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                row.type !== 'BaseProject' &&
                row.externalSupplierLines?.length > 0
              "
            >
              <div
                class="d-flex"
                *ngFor="let line of row.externalSupplierLines"
                [matTooltip]="line.line"
                [matTooltipDisabled]="
                  line.line == null || line.line.length === 0
                "
              >
                <mat-icon
                  *ngIf="line.finished"
                  svgIcon="check"
                  class="text-checkmark"
                ></mat-icon>
                <div>
                  <span class="strong">{{ line.header }}</span>
                  <span class="preserve-line-break">{{
                    line.line | shortenText : 50 | or
                  }}</span>
                </div>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="siteVisitor">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Toegewezen</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div class="line-height">
              <div *ngIf="row.projectPlacement?.employee">
                <div class="d-flex">
                  <div
                    class="employee-initials rounded-circle in-the-middle placer-margin"
                    [matTooltip]="
                      row.projectPlacement.employee.user?.firstName
                        | personName
                          : row.projectPlacement.employee.user?.lastName
                    "
                  >
                    <span
                      *ngIf="
                        !row.projectPlacement.employee.user?.profilePicture
                      "
                      >{{
                        row.projectPlacement.employee.user?.firstName
                          | initials
                            : row.projectPlacement.employee.user?.lastName
                      }}</span
                    >
                    <span
                      *ngIf="row.projectPlacement.employee.user?.profilePicture"
                    >
                      <img
                        class="rounded-circle"
                        width="30px"
                        height="30px"
                        [src]="
                          '/api/assets/' +
                          row.projectPlacement.employee.user.profilePicture
                            .uuid +
                          '/30'
                        "
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="quotationHandler">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle extra-right">
                <b>Toegewezen</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('quotationHandler__user__name')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div class="line-height">
              <div *ngIf="row.quotationHandler?.user">
                <div class="d-flex">
                  <div
                    class="employee-initials rounded-circle in-the-middle placer-margin"
                    [matTooltip]="
                      row.quotationHandler.user?.firstName
                        | personName : row.quotationHandler.user?.lastName
                    "
                  >
                    <span *ngIf="!row.quotationHandler.user?.profilePicture">{{
                      row.quotationHandler.user?.firstName
                        | initials : row.quotationHandler.user?.lastName
                    }}</span>
                    <span *ngIf="row.quotationHandler.user?.profilePicture">
                      <img
                        class="rounded-circle"
                        width="30px"
                        height="30px"
                        [src]="
                          '/api/assets/' +
                          row.quotationHandler.user.profilePicture.uuid +
                          '/30'
                        "
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="externalSupplierEmployee">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Toegewezen</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="row.type === 'BaseProject'">
              <div
                class="line-height"
                *ngFor="let prod of row.project.products; trackBy: trackById"
              >
                <ng-container
                  *ngIf="prod.externalSupplierEmployees?.length > 0"
                >
                  <div class="d-flex">
                    <div
                      *ngFor="
                        let employee of prod.externalSupplierEmployees;
                        trackBy: trackById
                      "
                      class="employee-initials rounded-circle in-the-middle placer-margin"
                      [matTooltip]="
                        employee.user?.firstName
                          | personName : employee.user?.lastName
                      "
                    >
                      <span *ngIf="!employee.user?.profilePicture">
                        {{
                          employee.user?.firstName
                            | initials : employee.user?.lastName
                        }}
                      </span>
                      <span *ngIf="employee.user?.profilePicture">
                        <img
                          class="rounded-circle"
                          width="30px"
                          height="30px"
                          [src]="
                            '/api/assets/' +
                            employee.user.profilePicture.uuid +
                            '/30'
                          "
                        />
                      </span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                row.type !== 'BaseProject' &&
                row.externalSupplierEmployees?.length > 0
              "
            >
              <div class="d-flex">
                <div
                  *ngFor="
                    let employee of row.externalSupplierEmployees;
                    trackBy: trackById
                  "
                  class="employee-initials rounded-circle in-the-middle placer-margin"
                  [matTooltip]="
                    employee.user?.firstName
                      | personName : employee.user?.lastName
                  "
                >
                  <span *ngIf="!employee.user?.profilePicture">
                    {{
                      employee.user?.firstName
                        | initials : employee.user?.lastName
                    }}
                  </span>
                  <span *ngIf="employee.user?.profilePicture">
                    <img
                      class="rounded-circle"
                      width="30px"
                      height="30px"
                      [src]="
                        '/api/assets/' +
                        employee.user.profilePicture.uuid +
                        '/30'
                      "
                    />
                  </span>
                </div>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="delayedReason">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Reden uitstelling</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <span
              *ngIf="row.delayedReason != null && row.delayedReason.length > 0"
              class="preserve-line-break"
              [matTooltip]="row.delayedReason"
              [matTooltipDisabled]="row.delayedReason.length < 30"
              >{{ row.delayedReason | shortenText : 30 }}</span
            >
            <span
              *ngIf="
                row.delayedReason == null || row.delayedReason.length === 0
              "
            >
              -
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="photo">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" mat-sort-header>
                <b>Foto</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div
              class="line-height in-the-middle-left"
              *ngFor="
                let prod of row.project.products;
                let isLast = last;
                trackBy: trackById
              "
            >
              <div class="d-flex">
                <div
                  *ngFor="
                    let asset of prod.productAssets;
                    let first = first;
                    trackBy: trackById
                  "
                >
                  <img
                    [ngClass]="first ? '' : 'hidden'"
                    width="30px"
                    height="30px"
                    [src]="'/api/assets/' + asset.asset.uuid + '/30'"
                    (click)="openlightbox(prod)"
                  />
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="mostRecentAdjustmentPhoto">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" mat-sort-header>
                <b>Foto</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div class="d-flex">
              <div
                *ngFor="
                  let asset of getFilteredProductAssets(
                    row.mostRecentlyExecutedProductAssets
                  );
                  let first = first;
                  trackBy: trackById
                "
              >
                <img
                  [ngClass]="first ? '' : 'hidden'"
                  width="30px"
                  height="30px"
                  [src]="'/api/assets/' + asset.asset.uuid + '/30'"
                  (click)="openMostRecentAdjustmentPhotosLightbox(row)"
                />
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="designPhoto">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" mat-sort-header>
                <b>Design</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container *ngIf="row.type === 'BaseProject'">
              <div
                class="line-height in-the-middle-left"
                *ngFor="
                  let prod of row.project.products;
                  let isLast = last;
                  trackBy: trackById
                "
              >
                <div class="d-flex">
                  <div
                    *ngFor="
                      let asset of prod.productAssets;
                      let first = first;
                      trackBy: trackById
                    "
                  >
                    <img
                      [ngClass]="first ? '' : 'hidden'"
                      width="30px"
                      height="30px"
                      [src]="'/api/assets/' + asset.asset.uuid + '/30'"
                      (click)="openlightbox(prod)"
                    />
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="row.type !== 'BaseProject' && row.projectPlacement != null"
            >
              <div class="d-flex">
                <div
                  *ngFor="
                    let asset of row.projectPlacement.projectPlacementAssets;
                    let first = first;
                    trackBy: trackById
                  "
                >
                  <img
                    [ngClass]="first ? '' : 'hidden'"
                    width="30px"
                    height="30px"
                    [src]="'/api/assets/' + asset.asset.uuid + '/30'"
                    (click)="openProjectPlacementLightbox(row.projectPlacement)"
                  />
                </div>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="thankYouMailSent">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <b>Bedankingsmail</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div class="checkmark-middle" *ngIf="row.thankYouMailSent">
              <span style="margin-left: -7.5px"
                ><mat-icon
                  class="checkmark-no-top-margin"
                  svgIcon="check"
                ></mat-icon
              ></span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="requestor">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <b>Aanvr.</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            (click)="openProject(row)"
            class="table-text"
            [matTooltip]="
              row.projectUser?.firstName
                | personName : row.projectUser?.lastName
            "
          >
            <div
              class="rounded-circle in-the-middle placer-margin"
              [ngClass]="
                getLocalStorageKey() === 'PendingProjectsComponent'
                  ? 'employee-initials'
                  : 'employee-initials-requestor'
              "
            >
              <span
                style="margin-top: 2px"
                *ngIf="!row.projectUser?.profilePicture"
              >
                {{
                  row.projectUser?.firstName
                    | initials : row.projectUser?.lastName
                }}</span
              >
              <span *ngIf="row.projectUser?.profilePicture">
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' + row.projectUser.profilePicture.uuid + '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayStatus">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <span
              [ngClass]="
                fixedSubProjectTypeClass != null
                  ? fixedSubProjectTypeClass
                  : (row.type
                    | overviewProjectTypeClass
                      : row.status
                      : row.withPlacement
                      : row.project?.typeMostRecentlyExecuted
                      : subProjectTypeRightMargin)
              "
              class="clickable status"
              (click)="navigateTab(row.id, row.project.id, row.displayStatus)"
            >
              {{
                fixedSubProjectTypeLabel != null
                  ? fixedSubProjectTypeLabel
                  : (row.type
                    | overviewProjectType
                      : row.status
                      : row.withPlacement
                      : row.project?.typeMostRecentlyExecuted)
              }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="star" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            (click)="$event.stopPropagation()"
            class="table-text"
          >
            <planning-shortcut
              *ngIf="assignOpen && row.id === assignPlanningId"
              [subProject]="row"
              (close)="openPlanningShortcut(null, $event)"
            ></planning-shortcut>
            <mat-menu #actionMenu="matMenu" class="table-text">
              <button
                mat-menu-item
                (click)="openModal(row)"
                class="center-text"
              >
                Acties
              </button>
              <button
                mat-menu-item
                (click)="openPlanningShortcut(row)"
                class="center-text"
              >
                Planning
              </button>
              <button
                mat-menu-item
                (click)="openNotificationMailModal(row)"
                class="center-text"
              >
                Notificatiemail
              </button>
              <button
                mat-menu-item
                (click)="generatePlacementSticker(row)"
                class="center-text"
              >
                Plakbrief
              </button>
              <button
                mat-menu-item
                (click)="sendThankYouMail(row)"
                class="center-text"
              >
                Bedankingsmail
                <span *ngIf="row.thankYouMailSent"
                  >&nbsp;&nbsp;<mat-icon
                    class="small-icon"
                    svgIcon="check"
                  ></mat-icon
                ></span>
              </button>
              <button
                mat-menu-item
                (click)="doAdjustment(row.project)"
                *ngIf="
                  getLocalStorageKey() === 'ExecutedProjectsComponent' &&
                  isBaseProject(row)
                "
              >
                Aanpassing
              </button>
              <button
                mat-menu-item
                (click)="doSoldRented(row.project)"
                *ngIf="
                  getLocalStorageKey() === 'ExecutedProjectsComponent' &&
                  isBaseProject(row)
                "
              >
                Verkocht/Verhuurd
              </button>
              <button
                mat-menu-item
                (click)="doRepo(row.project)"
                *ngIf="
                  getLocalStorageKey() === 'ExecutedProjectsComponent' &&
                  isBaseProject(row)
                "
              >
                Weghalen
              </button>
              <button
                mat-menu-item
                (click)="deleteProject(row)"
                class="center-text"
              >
                Verwijderen
              </button>
            </mat-menu>
            <div class="text-middle">
              <mat-icon
                class="fa-2x no-background"
                [matMenuTriggerFor]="actionMenu"
                (menuOpened)="openPlanningShortcut()"
                >more_vert
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th
            class="header-text align-text-center align-padding-container"
            mat-header-cell
            *matHeaderCellDef
          >
            <b>Type</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngFor="let product of row.project.products; trackBy: trackById"
              class="d-flex in-the-middle-left pending-container"
              matTooltip="{{
                product.type
                  | productType
                    : product.otherProductName
                    : product.overviewFormat
                  | joiner : ' - ' : product.boardType : product.placementType
              }}"
            >
              {{
                product.type | abbreviatedProductType : product.otherProductName
              }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="quotation">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <b>Offerte</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              class="d-flex in-the-middle-left pending-container {{
                row.quotationBackgroundClass
              }}"
            >
              <async-employee-with-badge
                *ngIf="row.needsQuotation"
                [employee]="row.quotationHandler"
                [svgIcon]="row.quotationBadgeIcon.icon"
                [transformClass]="row.quotationBadgeIcon.transformClass"
                [borderColor]="row.quotationBadgeIcon.borderColor"
              ></async-employee-with-badge>
              <span *ngIf="row.needsQuotation !== false" class="date-display">
                {{ row.displayQuotationDate }}
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="design">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <b>Ontwerp</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="!isBaseProject(row)"
              class="d-flex in-the-middle-left pending-container {{
                row.designBackgroundClass
              }}"
            >
              <async-employee-with-badge
                *ngIf="row.needsDesign && row.type !== 'Repo'"
                [employee]="row.adjustmentDesigner"
                [svgIcon]="row.designBadgeIcon.icon"
                [transformClass]="row.designBadgeIcon.transformClass"
                [borderColor]="row.designBadgeIcon.borderColor"
              ></async-employee-with-badge>
              <span
                *ngIf="row.needsDesign !== false && row.type !== 'Repo'"
                class="date-display"
              >
                {{ row.currentDesignDate | formatDate : '__/__' : 'dd/MM' }}
              </span>
            </div>
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="
                  let product of row.project.products;
                  let first = first;
                  let last = last;
                  trackBy: trackById
                "
                class="d-flex in-the-middle-left pending-container {{
                  product.designBackgroundClass
                }}"
                [ngClass]="first | pendingContainerClass : last"
              >
                <async-employee-with-badge
                  *ngIf="product.needsDesign"
                  [employee]="product.designer"
                  [svgIcon]="product.designBadgeIcon.icon"
                  [transformClass]="product.designBadgeIcon.transformClass"
                  [borderColor]="product.designBadgeIcon.borderColor"
                ></async-employee-with-badge>
                <span
                  *ngIf="product.needsDesign !== false"
                  class="date-display"
                >
                  {{ product.designByDate | formatDate : '__/__' : 'dd/MM' }}
                </span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="printJob">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <b>Printwerk</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="!isBaseProject(row)"
              class="d-flex in-the-middle-left pending-container {{
                row.printJobBackgroundClass
              }}"
            >
              <async-employee-with-badge
                *ngIf="row.needPrintwork && row.type !== 'Repo'"
                [employee]="row.adjustmentPrintworkHandler"
                [svgIcon]="row.printJobBadgeIcon.icon"
                [transformClass]="row.printJobBadgeIcon.transformClass"
                [borderColor]="row.printJobBadgeIcon.borderColor"
              ></async-employee-with-badge>
              <span
                *ngIf="row.needPrintwork !== false && row.type !== 'Repo'"
                class="date-display"
                >{{
                  row.currentPrintDate | formatDate : '__/__' : 'dd/MM'
                }}</span
              >
            </div>
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="
                  let product of row.project.products;
                  let first = first;
                  let last = last;
                  trackBy: trackById
                "
                class="d-flex in-the-middle-left pending-container {{
                  product.printJobBackgroundClass
                }}"
                [ngClass]="first | pendingContainerClass : last"
              >
                <async-employee-with-badge
                  *ngIf="product.needPrintwork"
                  [employee]="product.printworkHandler"
                  [svgIcon]="product.printJobBadgeIcon.icon"
                  [transformClass]="product.printJobBadgeIcon.transformClass"
                  [borderColor]="product.printJobBadgeIcon.borderColor"
                ></async-employee-with-badge>
                <span
                  *ngIf="product.needPrintwork !== false"
                  class="date-display"
                  >{{
                    product.printworkByDate | formatDate : '__/__' : 'dd/MM'
                  }}</span
                >
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="finishing">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <b>Afwerking</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="!isBaseProject(row)"
              class="d-flex in-the-middle-left pending-container {{
                row.finishBackgroundClass
              }}"
            >
              <async-employee-with-badge
                *ngIf="row.needFinish && row.type !== 'Repo'"
                [employee]="row.adjustmentFinisher"
                [svgIcon]="row.finishBadgeIcon.icon"
                [transformClass]="row.finishBadgeIcon.transformClass"
                [borderColor]="row.finishBadgeIcon.borderColor"
              ></async-employee-with-badge>
              <span
                *ngIf="row.needFinish !== false && row.type !== 'Repo'"
                class="date-display"
              >
                {{ row.currentFinishDate | formatDate : '__/__' : 'dd/MM' }}
              </span>
            </div>
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="
                  let product of row.project.products;
                  let first = first;
                  let last = last;
                  trackBy: trackById
                "
                class="d-flex in-the-middle-left pending-container {{
                  product.finishBackgroundClass
                }}"
                [ngClass]="getPendingContainerClass(first, last)"
              >
                <async-employee-with-badge
                  *ngIf="product.needFinish"
                  [employee]="product.finisher"
                  [svgIcon]="product.finishBadgeIcon.icon"
                  [transformClass]="product.finishBadgeIcon.transformClass"
                  [borderColor]="product.finishBadgeIcon.borderColor"
                ></async-employee-with-badge>
                <span *ngIf="product.needFinish !== false" class="date-display">
                  {{ product.finishByDate | formatDate : '__/__' : 'dd/MM' }}
                </span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="placement">
          <th class="header-text" mat-header-cell *matHeaderCellDef>
            <b>Plaatsing</b>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <ng-container *ngIf="!isBaseProject(row)">
              <div
                class="d-flex in-the-middle-left pending-container {{
                  row.placementBackgroundClass
                }}"
              >
                <async-employee-with-badge
                  *ngIf="row.withPlacement"
                  [employee]="row.firstPlacerDisplay"
                  [svgIcon]="row.placementBadgeIcon.icon"
                  [transformClass]="row.placementBadgeIcon.transformClass"
                  [borderColor]="row.placementBadgeIcon.borderColor"
                  [locationVerification]="true"
                ></async-employee-with-badge>
                <span *ngIf="row.withPlacement !== false" class="date-display">
                  {{
                    row.currentConfirmedPlacementDate
                      | formatDate : '__/__' : 'dd/MM'
                  }}
                </span>
              </div>
            </ng-container>
            <ng-container *ngIf="isBaseProject(row)">
              <div
                *ngFor="
                  let product of row.project.products;
                  let first = first;
                  let last = last;
                  trackBy: trackById
                "
                class="d-flex in-the-middle-left pending-container {{
                  product.placementBackgroundClass
                }}"
                [ngClass]="getPendingContainerClass(first, last)"
              >
                <async-employee-with-badge
                  *ngIf="row.withPlacement"
                  [employee]="product.firstPlacerDisplay"
                  [svgIcon]="product.placementBadgeIcon.icon"
                  [transformClass]="product.placementBadgeIcon.transformClass"
                  [borderColor]="product.placementBadgeIcon.borderColor"
                  [locationVerification]="true"
                ></async-employee-with-badge>
                <span *ngIf="row.withPlacement !== false" class="date-display">
                  {{
                    product.productPlacement?.actualPlacementDate
                      | formatDate : '__/__' : 'dd/MM'
                  }}
                </span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr
          [ngClass]="row.applyGreenBackground ? 'green' : ''"
          mat-row
          class="table-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>

    <div *ngIf="projects.length === 0" class="no-result-text">
      <div>Geen resultaten gevonden</div>
    </div>
    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
    ></mat-paginator>
  </div>
</div>
